/* @flow */

import {
    NIVEL_FUNCIONARIO,
    NIVEL_CLIENTE,
    NIVEL_ADMIN,
    NIVEL_MASTER,
    NIVEL_SUPORTE,
} from './constants';

import { type Nivel } from './types';

const badge = (cor: string, nome: string) => `<span class="m-badge m-badge--${cor} m-badge--wide">${nome}</span>`;

const labelNivel = (nivel: Nivel) => {
    switch (nivel) {
    case NIVEL_FUNCIONARIO: return badge('info', 'Funcionário');
    case NIVEL_CLIENTE: return badge('primary', 'Cliente');
    case NIVEL_ADMIN: return badge('brand', 'Administrador');
    case NIVEL_MASTER: return badge('focus', 'Master');
    case NIVEL_SUPORTE: return badge('accent', 'Suporte');
    default: return badge('danger', nivel);
    }
};

export default labelNivel;
